<template>
	<div
		class="quest-story-replay-box"
		:class="`quest-story-replay-box--${type}`"
	>
		<RaggedBoxBackground :slug="type" />
		<div class="quest-story-replay-box__content">
			<span class="quest-story-replay-box__heading">
				<ShrinkText
					:font-size="20"
					:text="heading"
					:max-line-limit="2"
					is-uppercase
					:text-align="TextAlign.LEFT"
				/>
			</span>
			<AppIconButton :type="IconTypes.PLAY" @click="handleStoryPlay" />
		</div>
	</div>
</template>

<script lang="ts" setup>
import AppIconButton from "@/components/AppIconButton.vue";
import RaggedBoxBackground from "@/components/SVG/RaggedBoxBackground.vue";
import useQuestStore from "@/store/useQuestStore";
import type { QuestActive } from "@/types/quest";
import { IconTypes, TextAlign } from "@/types/ui";
import ShrinkText from "../ShrinkText.vue";

interface Props {
	heading: string;
	quest?: QuestActive;
	type: string;
	id: number;
}

const { heading, quest, type, id } = defineProps<Props>();

const emit = defineEmits(["play"]);

const handleStoryPlay = (): void => {
	if (quest) {
		useQuestStore().startNarrative(quest);
	}
	emit("play", id, quest === undefined);
};
</script>

<style lang="scss" scoped>
.quest-story-replay-box {
	position: relative;
	width: 100%;
	@include flex-col-center;
	filter: drop-shadow(0 0 0.125rem rgba(0, 0, 0, 0.4));

	&__content {
		position: absolute;
		@include flex-row-center;
		justify-content: space-between;
		padding: 0 0.75rem;
		width: 100%;
		height: 100%;

		.quest-story-replay-box-text {
			color: #372615;
			font-weight: bold;
			font-size: 0.875rem;
		}
	}

	&__heading {
		padding-bottom: 0.25rem;
		max-width: 80%;
		color: #372615;
		font-weight: 800;
		font-size: 1.25rem;
		text-align: left;
	}

	:deep(.ragged-box-bg) {
		position: relative;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}

	:deep(.progress-bar) {
		flex-shrink: 0;
		margin-top: 0.3rem;
	}

	:deep(.icon-check) {
		margin-top: 0.25rem;
		margin-left: 0.25rem;
		width: 0.75rem;
		height: 0.75rem;
	}
}
</style>
